<ng-container *ngIf="canEdit; else readOnly">
    <span class="inputNumberEditable">
        <input type="number" [min]="minValue" [max]="maxValue" [step]="1" [(ngModel)]="value" [disabled]="isDisabled" (change)="onNumberValueChange($event)" (keyup)="onNumberValueKeyup($event)" (keydown)="onNumberValueKeydown($event)"/>
        <span *ngIf="isPercentage">%</span>
    </span>
</ng-container>
<ng-template #readOnly>
    <span class="readOnlyInputNumber">{{value}}<span *ngIf="isPercentage">%</span></span>
</ng-template>